document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sliding-banner-variant').forEach((variant) => {
    const stage = variant.querySelector('.sliding-banner-stage');
    const slider = variant.querySelector('.sliding-banner-slick');
    const pauseButton = variant.querySelector('.sliding-banner-pause-button');
    const dots = variant.querySelector('.sliding-banner-dots');
    const status = variant.querySelector('[role="status"]');

    if (!stage || !slider || !pauseButton || !dots || typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick !== 'function') {
      return;
    }

    const $slider = window.jQuery(slider);
    const totalSlides = slider.querySelectorAll('.sliding-banner-slide').length;
    let userPaused = false;
    let isHovering = false;
    let isFocused = false;

    const setButtonStatus = () => {
      pauseButton.classList.toggle('is-paused', userPaused);
      pauseButton.setAttribute('aria-label', userPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
      pauseButton.setAttribute('aria-pressed', String(userPaused));
    };

    const updateRotation = () => {
      if (totalSlides < 2) {
        return;
      }

      if (userPaused || isHovering || isFocused) {
        $slider.slick('slickPause');
      } else {
        $slider.slick('slickPlay');
      }
    };

    const updateAccessibility = (currentSlide = 0) => {
      const slides = Array.from(slider.querySelectorAll('.sliding-banner-slide'));
      const activeIndex = Math.min(Math.max(currentSlide, 0), Math.max(slides.length - 1, 0));

      slides.forEach((slide, index) => {
        const isCurrent = index === activeIndex;
        const link = slide.querySelector('a');

        slide.setAttribute('aria-hidden', String(!isCurrent));
        if (isCurrent) {
          slide.setAttribute('aria-current', 'true');
        } else {
          slide.removeAttribute('aria-current');
        }

        if (link) {
          link.setAttribute('tabindex', isCurrent ? '0' : '-1');
        }
      });

      dots.querySelectorAll('.slick-dots li').forEach((dot, index) => {
        const button = dot.querySelector('button');
        if (!button) {
          return;
        }

        button.textContent = '';
        button.setAttribute('aria-label', `Go to slide ${index + 1} of ${totalSlides}`);
        button.setAttribute('tabindex', '0');
        if (index === activeIndex) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }

        dot.removeAttribute('role');
        button.removeAttribute('aria-selected');
      });

      if (status) {
        status.textContent = `Slide ${activeIndex + 1} of ${totalSlides}`;
      }
    };

    $slider.on('init', () => {
      const generatedDots = slider.querySelector('.slick-dots');
      if (generatedDots) {
        dots.appendChild(generatedDots);
      }
      updateAccessibility(0);
    });
    $slider.on('afterChange', (event, slick, currentSlide) => updateAccessibility(currentSlide));

    $slider.slick({
      arrows: false,
      dots: true,
      accessibility: false,
      infinite: false,
      autoplay: totalSlides > 1,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
    });

    pauseButton.disabled = totalSlides < 2;
    pauseButton.addEventListener('click', () => {
      userPaused = !userPaused;
      setButtonStatus();
      updateRotation();
    });

    const pauseForHover = () => {
      isHovering = true;
      updateRotation();
    };
    const resumeAfterHover = () => {
      isHovering = false;
      updateRotation();
    };

    stage.addEventListener('mouseenter', pauseForHover);
    stage.addEventListener('mouseleave', resumeAfterHover);
    dots.addEventListener('mouseenter', pauseForHover);
    dots.addEventListener('mouseleave', resumeAfterHover);
    pauseButton.addEventListener('mouseenter', resumeAfterHover);
    pauseButton.addEventListener('mouseleave', () => {
      if (stage.matches(':hover')) {
        pauseForHover();
      }
    });
    variant.addEventListener('focusin', (event) => {
      if (event.target !== pauseButton) {
        isFocused = true;
        updateRotation();
      }
    });
    variant.addEventListener('focusout', (event) => {
      if (event.relatedTarget === pauseButton || !variant.contains(event.relatedTarget)) {
        isFocused = false;
        updateRotation();
      }
    });

    setButtonStatus();
    updateAccessibility(0);
  });
});
